import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { PopUpRenderData } from '../../../../networkPopUps/types';
import { BaseNetworkActionHelper } from '../base.network.action.helper';
import { translateFn } from '../../../../../utils/translator.helper';
import { ConsoleRequest, DataProviderEntity, DataProviderType } from '../../../../../utils/request';
import { Feature } from '@nirvana/shared/constants';

interface GetFeaturesResponse {
  features: Array<{ key: boolean }>;
  success: boolean;
}

export class SubmitToSandboxActionHelper extends BaseNetworkActionHelper {
  public async processAction(selectedTargets: Array<ProtectedEntity>): Promise<PopUpRenderData> {
    const validResponse: PopUpRenderData = {
      isError: false,
    };

    const errorResponse: PopUpRenderData = {
      isError: true,
      errorData: {
        title: translateFn('Cannot submit samples to Sandbox Analyzer'),
        buttonText: translateFn('Close'),
        errorMessages: [
          translateFn('The company that owns the endpoint does not have the required GravityZone license.'),
        ],
      },
    };

    const selectedEndpoint = selectedTargets[0];

    if (!selectedEndpoint.company) {
      console.error('Company data missing from selected target.');
      return errorResponse;
    }

    try {
      const companyFeaturesResponse = await ConsoleRequest.createRequest<GetFeaturesResponse>({
        dataProviderType: DataProviderType.CORE,
        dataProviderEntity: DataProviderEntity.SYSTEM,
        endpoint: 'FeaturesManager',
        method: 'getFeaturesByCompany',
        payload: {
          companyId: selectedEndpoint.company.id,
        },
      });

      if (!companyFeaturesResponse.success) {
        console.error('Could not verify selected target company features');
        return errorResponse;
      }

      return companyFeaturesResponse.features[Feature.PRODUCT_FEATURE_SANDBOX_ANALYZER_USABLE]
        ? validResponse
        : errorResponse;
    } catch (error: any) {
      console.error(error);
      return errorResponse;
    }
  }
}
